import "./styles.scss";
import { Rectangle, Surface } from "recharts";
export const CustomLegend = ({ isCompare = false, payload, ...props }) => {
  if (isCompare) {
    const firstHalf = payload.slice(0, payload.length / 2);
    const secondHalf = payload.slice(payload.length / 2);

    return (
      <div className="chart__custom-legend">
        <ul className="recharts-default-legend">
          {firstHalf.map((entry, index) => {
            const { value, fillOpacity, color } = entry;

            return (
              <li
                key={`item-${index}`}
                className="recharts-legend-item  chart__custom-legend-item"
                style={{
                  color,
                }}
              >
                <Surface
                  width={10}
                  height={10}
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 2,
                    opacity: fillOpacity,
                  }}
                >
                  <Rectangle width={10} height={10} radius={2} fill={color} />
                </Surface>
                <span className="chart__custom-legend-item-label">{value}</span>
              </li>
            );
          })}
        </ul>
        <ul className="recharts-default-legend" style={{ marginTop: 5 }}>
          {secondHalf.map((entry, index) => {
            const { value, color, fillOpacity } = entry;
            return (
              <li
                key={`item-${index}`}
                className="recharts-legend-item  chart__custom-legend-item"
                style={{
                  color,
                }}
              >
                <Surface
                  width={10}
                  height={10}
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 2,
                    opacity: 0.4,
                  }}
                >
                  <Rectangle width={10} height={10} radius={2} fill={color} />
                </Surface>
                <span className="chart__custom-legend-item-label">{value}</span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return (
    <ul className="recharts-default-legend">
      {payload.map((entry, index) => {
        const { value, color } = entry;

        return (
          <li
            key={`item-${index}`}
            className="recharts-legend-item  chart__custom-legend-item"
            style={{
              color,
            }}
          >
            <Surface
              width={10}
              height={10}
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                marginRight: 2,
              }}
            >
              <Rectangle width={10} height={10} radius={2} fill={color} />
            </Surface>
            <span className="chart__custom-legend-item-label">{value}</span>
          </li>
        );
      })}
    </ul>
  );
};
